import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-a453ea02"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "data-ingestion" };
const _hoisted_2 = { class: "data-ingestion__header" };
const _hoisted_3 = { class: "data-ingestion__title" };
const _hoisted_4 = ["src", "alt"];
const _hoisted_5 = { class: "data-ingestion__heading" };
const _hoisted_6 = ["src", "alt"];
const _hoisted_7 = { class: "data-ingestion__display" };
const _hoisted_8 = { class: "data-ingestion__alerts" };
const _hoisted_9 = { class: "data-ingestion__icon" };
const _hoisted_10 = ["src", "alt"];
const _hoisted_11 = ["innerHTML"];
import { computed } from 'vue';
import i18n from '@/i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'DataIngestionTodayAlerts',
    props: {
        alerts: {}
    },
    setup(__props) {
        const props = __props;
        const successToday = computed(() => props.alerts[0].status === 'success');
        const infoMessages = {
            success: {
                title: i18n.global.t('welcome.data-ingestion.success-title'),
                text: i18n.global.t('welcome.data-ingestion.success-text'),
            },
            alert: {
                title: i18n.global.t('welcome.data-ingestion.alert'),
                text: i18n.global.t('welcome.data-ingestion.description'),
            },
        };
        const info = computed(() => (successToday.value ? infoMessages.success : infoMessages.alert));
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("img", {
                            src: require('@/assets/img/icons/welcome/notification.svg'),
                            alt: _ctx.$t('welcome.data-ingestion.alt-bell'),
                            class: "data-ingestion__bell"
                        }, null, 8, _hoisted_4),
                        _createElementVNode("h3", _hoisted_5, _toDisplayString(info.value.title), 1)
                    ]),
                    _createVNode(_component_router_link, {
                        to: { name: 'connect-data-ingestion-history' },
                        class: "data-ingestion__link"
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('welcome.data-ingestion.link-text')), 1),
                            _createElementVNode("img", {
                                src: require('@/assets/img/icons/welcome/arrow-right.svg'),
                                alt: _ctx.$t('welcome.data-ingestion.alt-arrow')
                            }, null, 8, _hoisted_6)
                        ]),
                        _: 1
                    })
                ]),
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("p", null, _toDisplayString(info.value.text), 1),
                    _createElementVNode("div", _hoisted_8, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.alerts, (alert, idx) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: idx,
                                class: _normalizeClass(`data-ingestion__alert data-ingestion__alert--${alert.status}`)
                            }, [
                                _createElementVNode("span", _hoisted_9, [
                                    _createElementVNode("img", {
                                        src: require('@/assets/img/icons/welcome/alert.svg'),
                                        alt: _ctx.$t('welcome.data-ingestion.alt-alert')
                                    }, null, 8, _hoisted_10)
                                ]),
                                _createElementVNode("span", {
                                    innerHTML: alert.message
                                }, null, 8, _hoisted_11)
                            ], 2));
                        }), 128))
                    ])
                ])
            ]));
        };
    }
});
